import { FC } from 'react'
import { Bid, USBid } from 'modules/domain/bid/types'
import { refetchFunc } from 'modules/domain/common/hooks'
import { isRussia, isUS } from 'env'
import { RUBidDetailProduct } from './RUBidDetailProduct'
import { USEditableBidInfo } from 'views/components/USEditableBidInfo/USEditableBidInfo'

type Props = {
  bid: Bid
  readOnly: boolean
  refetch: refetchFunc
}

export const BidDetailProduct: FC<Props> = ({ bid, refetch, readOnly }) => {
  /* TODO Enable after finalization of the api!!! */
  // const readOnlyUSBidDetail =
  //   deal.status === DealStatusTypes.DRAFT || bid.source === BidSources.BARCHART || !(bid as USBid).contract_type

  /* TODO Turn off after finalizing the api!!! */
  const readOnlyUSBidDetail = true

  if (isRussia) return <RUBidDetailProduct bid={bid} readOnly={readOnly} refetch={refetch} />

  if (isUS)
    return (
      <USEditableBidInfo bid={bid as USBid} refreshBid={refetch} usedOnPage="deal" readOnly={readOnlyUSBidDetail} />
    )
}
